export default new class BlockQuoteAuthor {
  constructor() {
    this.blockquoteAuthor = 'blockquote-author';
    this.$blockquoteAuthor = $(`.${this.blockquoteAuthor}`);

    if (!this.$blockquoteAuthor.length) return;

    this.blockquoteAuthorImg = 'blockquote-author__img';
    this.noImgClass = '_no-img';

    this.init();
  }

  init() {
    this.checkAuthorIcon();
  }

  /**
     * Check author icon
     */
  checkAuthorIcon() {
    const $imgList = $(`.${this.blockquoteAuthorImg}`);
    const self = this;

    $imgList.each(function addNoImgClass() {
      const $img = $(this);
      const attr = $img.attr('src');

      if (!attr.trim()) {
        $img.addClass(self.noImgClass);
      }
    });
  }
}();
